import { useLocation } from 'quartz-routing/react-router';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { getIsIframePreviewTestUrl } from '../../utils/urls';
export const useIsIframePreviewTestMode = () => {
  const {
    pathname
  } = useLocation();
  const {
    checkoutSession
  } = usePaymentFormContext();
  const isIframePreviewTestUrl = getIsIframePreviewTestUrl(pathname);
  const isLiveMode = checkoutSession.liveMode;
  return {
    isIframePreviewTestMode: !isLiveMode && isIframePreviewTestUrl
  };
};